/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ReactElement,
} from 'react';
import styled from 'styled-components';

import type {
  DropdownIndicatorProps,
} from 'react-select';

import type {
  OptionTypeBase,
} from '../types';

const Wrapper = styled.div(({
  theme: {
    colors,
  },
}) => ({
  display: 'flex',
  boxSizing: 'border-box',
  paddingLeft: 7,
  paddingRight: 7,
  transition: 'color 150ms ease 0s',
  color: colors.NEUTRAL_INPUT,
  minWidth: 36,
}));

export function DropdownIndicator<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
>({
  innerProps,
  className,
}: DropdownIndicatorProps<OptionType, IsMulti>): ReactElement {
  return (
    <Wrapper
      {...innerProps as any}
      className={className}
    >
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.97659 9.50326H10.5033L13.8299 12.8366L12.8366 13.8299L9.50326 10.5033V9.97659L9.32326 9.78992C8.56326 10.4433 7.57659 10.8366 6.50326 10.8366C4.10992 10.8366 2.16992 8.89659 2.16992 6.50326C2.16992 4.10992 4.10992 2.16992 6.50326 2.16992C8.89659 2.16992 10.8366 4.10992 10.8366 6.50326C10.8366 7.57659 10.4433 8.56326 9.78992 9.32326L9.97659 9.50326ZM3.50326 6.50326C3.50326 8.16326 4.84326 9.50326 6.50326 9.50326C8.16326 9.50326 9.50326 8.16326 9.50326 6.50326C9.50326 4.84326 8.16326 3.50326 6.50326 3.50326C4.84326 3.50326 3.50326 4.84326 3.50326 6.50326Z"
        />
      </svg>
    </Wrapper>
  );
}
